import type { Chess, Move } from "chess.js";
import type { DemoExpect } from "@/content/types";

/** True when the position after `last` satisfies a demo's goal. Shared by the UI and the validator. */
export function meetsExpect(c: Chess, last: Move, expect: DemoExpect): boolean {
  switch (expect) {
    case "checkmate":
      return c.isCheckmate();
    case "stalemate":
      return c.isStalemate();
    case "check":
      return c.inCheck();
    case "threefold":
      return c.isThreefoldRepetition();
    case "fifty":
      return c.isDrawByFiftyMoves();
    case "insufficient":
      return c.isInsufficientMaterial();
    case "enpassant":
      return last.isEnPassant();
    case "castle":
      return last.isKingsideCastle() || last.isQueensideCastle();
    case "promotion":
      return last.isPromotion();
  }
}

/** Goals where any move that achieves them is as good as the scripted one. */
export const OPEN_ENDED: DemoExpect[] = ["checkmate", "stalemate", "insufficient", "fifty"];
